import React, { ChangeEvent, useEffect, useState } from 'react';

import { Button } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';

import { Cross, Search } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { ChakraStyleInput } from 'uiToolkitV1/InputV2/ChakraStyleInput';

export interface AgGridSearchBarProps {
  gridRef: React.MutableRefObject<AgGridReact>;
  placeholder?: string;
  inputGroupProps?: any;
  width?: string | number;
}

export const AgGridSearchBar = ({
  gridRef,
  placeholder = 'Search',
  inputGroupProps = {},
  width = '320px',
  ...props
}: AgGridSearchBarProps) => {
  const [searchText, setSearchText] = useState('');

  const handleTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    const updatedText = e.target.value;
    setSearchText(updatedText);
  };

  const clearText = () => {
    setSearchText('');
  };

  /*
    on searchText change set quick filter if
    - searchText is not null (on first run of effect) and
    - grid is initialized
    */
  useEffect(() => {
    if (gridRef?.current?.api) {
      gridRef?.current?.api?.setGridOption('quickFilterText', searchText);
    }
  }, [gridRef, searchText]);

  return (
    <ChakraStyleInput
      placeholder={placeholder}
      value={searchText}
      onChange={handleTextChange}
      leftComponent={<Search />}
      rightComponent={
        searchText && (
          <Button display="flex" alignItems="center" variant="unstyled" onClick={clearText}>
            <Cross />
          </Button>
        )
      }
      borderColor="#EBEFF3 !important"
      bgColor="neutral.FDFDFD"
      inputGroupProps={{
        minW: width,
        maxW: width,
        ...inputGroupProps,
      }}
      color="text.g1"
      display={isMobileView() ? 'none' : 'block'}
      _placeholder={{
        color: 'text.g3',
      }}
      _hover={{
        borderColor: '#333333 !important',
        _placeholder: {
          color: 'text.g1',
        },
      }}
      {...props}
    />
  );
};
